import axios from 'axios';
import { getIdToken } from '@/pages/MyAccount/components/firebaseIdToken';

/**
 * Customer Health overview (Super Admin only) — POST /get-engagement-overview
 * (teamio-serverless-api/lifecycle-service, plan docs/plans/2026-10-09-customer-lifecycle-phase1-plan.md).
 *
 * THE SERVER IS THE GATE. It verifies this Firebase ID token and checks it against its own Super Admin
 * allowlist before it runs a single query; the page-level check in SuperAdmin.vue only decides what to draw.
 * So this call FAILS CLOSED: with no token it does not call at all (a tokenless request can only be a 401).
 * READ-ONLY: the only body it can send is `{ refresh }`, which asks the server to skip its 10-minute cache.
 */

/** The server's whole-run deadline is 20 s and API Gateway cuts off at 29 s; wait a little longer than that. */
export const OVERVIEW_TIMEOUT_MS = 35000;

export const NO_TOKEN_MESSAGE = "Couldn't confirm your sign-in. Reload the page and try again.";

export async function fetchEngagementOverview({ auth, refresh = false } = {}) {
  const idToken = await getIdToken(auth);
  if (!idToken) throw new Error(NO_TOKEN_MESSAGE);
  const { data } = await axios.post(
    '/get-engagement-overview',
    { refresh: refresh === true },
    { headers: { Authorization: `Bearer ${idToken}` }, timeout: OVERVIEW_TIMEOUT_MS, crossdomain: true }
  );
  return data;
}
